import { DistanceCalculatorOverview } from "../DistanceCalculatorOverview";
import { RateIndexDataSummary } from "../RateIndexDataSummary";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Map, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDistanceRateIndexCalculator extends Layout {
    buttonCalculate: Button;
    buttonFetchOtherResults: Button;
    buttonQuote: Button;
    buttonRouteDetails: Button;
    clearStops: Label;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    labelDistanceCalculator: Label;
    labelMapinfo: Label;
    labelOverviewHeader: Label;
    labelRateIndex: Label;
    layoutDistanceCalculationOverview: DistanceCalculatorOverview;
    layoutTotalRatesSummary: RateIndexDataSummary;
    mapRoute: Map;
    panelDisplayMap: Panel;
    panelDistanceCalculator: Panel;
    panelOverview: Panel;
    panelRateIndexConfig: Panel;
    panelTotalRatesSummary: Panel;
    sourceDistanceCalculator: DataSource;
    sourceRateIndexControl: DataSource;
    sourceStops: DataSource;
    switchExcludeFuelSurcharge: Switch;
    tableStops: Table;
    textboxAreaType: Textbox;
    textboxEscalationType: Textbox;
    textboxMarginPercentage: Textbox;
    textboxTimeFrame: Textbox;
    textboxTimeFrameContract: Textbox;
    textboxTrailerType: Textbox;
}
